module.exports = __webpack_public_path__ + "img/namsan_gallery2.614b39c0.jpg";